export const ABSENT_OPTIONS = [
  { value: 'Нет', label: 'Нет' },
  { value: 'Кондиционер', label: 'Кондиционер' },
  { value: 'Кухня', label: 'Кухня' },
  { value: 'Мебель', label: 'Мебель' },
];
